






































































import Component from 'vue-class-component';
import { Emit, Watch } from 'vue-property-decorator';
import { AgentOfficeCriteria } from '../../../components/criteria/agent-office-criteria';
import sitesApi from '@/api/sites.api';
import { formatDate, createBigPeriodListItems } from '@/utils';
import {
    IDictionary,
    IFormControl,
    IGetLoginLogs,
    ICompany,
    IListItem,
    ICriterion,
    DateRangeMapper,
    ISite
} from '../../../entities';
import * as types from '../../../store/types';
import { mapGetters } from 'vuex';

@Component({
    computed: mapGetters({
        companyPermissions: types.AUTH_HAS_COMPANY_PERMISSIONS,
        adminPermissions: types.AUTH_HAS_ADMIN_PERMISSIONS
    })
})
export default class ClickOutsCriteriaComponent extends AgentOfficeCriteria {
    public dateRangeHints: IListItem[] = [
        { heading: 'Choose payout period', value: null },
        ...createBigPeriodListItems()
    ];

    public formState: IDictionary<IFormControl> = this.createFormState();

    public sites: IListItem[] = [{ heading: 'All Sites', value: null }];

    public created() {
        super.created();
        sitesApi.list().then((items: ISite[]) => {
            const mapped = items.map((x) => {
                return { value: x.id, heading: x.sitename };
            });
            this.sites = [{ heading: 'All Sites', value: null }, ...mapped];
        });
        this.doSearch();
    }

    public createFormState(): IDictionary<IFormControl> {
        const defValues = this.defaultFormValues();
        return {
            companyId: {
                key: 'companyId',
                label: 'Office',
                value: null
            },
            agentId: {
                key: 'agentId',
                label: 'Agent',
                value: null
            },
            ip: {
                key: 'ip',
                label: 'IP Address',
                value: ''
            },
            siteId: {
                key: 'siteId',
                label: 'Site',
                value: null
            },
            dateRange: {
                key: 'dateRange',
                label: 'Date',
                value: this.getDefaultDateRange(),
                mapper: DateRangeMapper
            }
        };
    }

    public defaultFormValues(): IDictionary<any> {
        return {
            companyId: null,
            agentId: null,
            ip: '',
            siteId: null,
            dateRange: this.getDefaultDateRange()
        };
    }

    public getQueryObject(formState: IDictionary<IFormControl>) {
        return {
            ipAddress: formState.ip.value ? formState.ip.value.trim() : null,
            companyId: formState.companyId.value,
            agentId: formState.agentId.value,
            siteId: formState.siteId.value,
            start: formatDate(formState.dateRange.value.start),
            end: formatDate(formState.dateRange.value.end)
        };
    }

    @Emit()
    public search(body) {
        this.saveDateRange({
            start: body.start,
            end: body.end
        });
    }

    @Watch('formState.companyId.value')
    private onCompanyIdChanged(val: string, oldVal: string) {
        this._reloadAgents(this.formState.companyId.value);
    }

    @Watch('$route') private onRouteChanged(val: string, oldVal: string) {
        this.doSearch();
    }
}
